#notification-event-preferences{display:flex;flex-direction:column}#notification-event-preferences>div{display:flex;flex-direction:row;padding:4% 0%}#notification-event-preferences>div>div{flex:0 1 20%;text-align:center}
/*# sourceMappingURL=/ba/public/app-notification-event-preferences.component.css.map */
